"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _ScrollView = _interopRequireDefault(require("react-native-web/dist/exports/ScrollView"));

var _View = _interopRequireDefault(require("react-native-web/dist/exports/View"));

var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/exports/StyleSheet"));

var _lodash = _interopRequireDefault(require("lodash"));

var _Placeholder = _interopRequireDefault(require("./Placeholder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var CardGrid = function CardGrid(_ref) {
  var style = _ref.style,
      children = _ref.children,
      _ref$nCols = _ref.nCols,
      nCols = _ref$nCols === void 0 ? 3 : _ref$nCols,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 40 : _ref$padding,
      unused = _objectWithoutProperties(_ref, ["style", "children", "nCols", "padding"]);

  // the style for cards
  var card = {
    marginBottom: padding,
    marginRight: padding // the style of the last card

  };
  var lastCard = {
    marginBottom: padding // get the list of children

  };
  var cards = React.Children.toArray(children);
  return React.createElement(_ScrollView.default, _extends({}, unused, {
    style: [styles.container, style]
  }), _lodash.default.chunk(cards, nCols).map(function (row, i) {
    return React.createElement(_View.default, {
      style: styles.row,
      key: "row-".concat(i)
    }, row.map(function (child, i) {
      // the style to apply to the card
      var cardStyle = i === row.length - 1 ? lastCard : card;
      return React.createElement(_View.default, {
        style: [styles.card, cardStyle],
        key: "card-".concat(i)
      }, child);
    }), _toConsumableArray(new Array(nCols - row.length)).map(function (_, i) {
      return React.createElement(_Placeholder.default, {
        style: styles.cardWrapper,
        key: "placeholder-".concat(i)
      });
    }));
  }));
};

var styles = _StyleSheet.default.create({
  container: {
    padding: 40
  },
  row: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-around'
  },
  cardWrapper: {
    flex: 1,
    marginRight: 40,
    marginBottom: 40
  },
  card: {
    flex: 1
  }
});

var _default = CardGrid;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-core/components/card/CardGrid/index.js
// module id = ./node_modules/quark-core/components/card/CardGrid/index.js
// module chunks = 0